import React, { useCallback } from 'react';
import {
  ListItemIcon,
  ListItemText,
  ListItem,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { RemoveCircle } from '@material-ui/icons';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import { User } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  removeIconCell: {
    justifyContent: 'flex-end'
  },
  user: {
    borderBottom: 'none'
  },
  button: {
    padding: theme.spacing(0)
  },
  resourceListItem: {
    paddingRight: theme.spacing(0.75)
  }
}));

const useUserOverrideStyles = makeStyles(theme => ({
  name: {
    padding: theme.spacing(0, 1)
  }
}));

export const PreferredResourcesListItem = ({
  onRemove,
  resource,
  inputRef
}) => {
  const classes = useStyles();
  const userOverrideClasses = useUserOverrideStyles();
  const { formatMessage } = useIntl();

  const onRemoveHandler = useCallback(() => {
    onRemove(resource);
  }, [onRemove, resource]);

  return (
    <ListItem className={classes.resourceListItem}>
      <ListItemText className={classes.user}>
        <User user={resource} classes={userOverrideClasses} />
      </ListItemText>
      <ListItemIcon className={classes.removeIconCell}>
        <IconButton
          onClick={onRemoveHandler}
          className={classes.button}
          aria-label={formatMessage(
            {
              id: 'resourceRequestDrawerDetails.removeResource'
            },
            { name: resource.displayText }
          )}
          ref={inputRef}
        >
          <RemoveCircle />
        </IconButton>
      </ListItemIcon>
    </ListItem>
  );
};

PreferredResourcesListItem.propTypes = {
  onRemove: PropTypes.func,
  resource: PropTypes.object,
  inputRef: PropTypes.object
};

export default PreferredResourcesListItem;
